var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{class:{ 'save-indicator': true, 'save-indicator-active': _vm.isActive }},[_vm._v(" "+_vm._s(_vm.$t('allg_saving'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }